import React from "react";
import { IMAGE_BASE_URL } from "../data/baseURL";

const Overview = ({ where_work_overview }) => {
  return (
    <div className="container-fluid pt-7" id="overview">
      <div className="ms-47 me-47">
        <div className="row">
          <div className="col-lg-2">
            <h1 className="fs-28 text-capitalize">Overview</h1>
          </div>
          <div className="col-lg-10 fs-18">
            <p
              className="text-align-justify"
              dangerouslySetInnerHTML={{
                __html: where_work_overview?.description,
              }}
            />
            <div className="pt-7 pb-7">
              <img
                src={`${IMAGE_BASE_URL}/${where_work_overview?.image}`}
                className="img-fluid"
                alt=""
              />
            </div>
          </div>
        </div>
        <hr />
      </div>
    </div>
  );
};

export default Overview;
